import Styles from './InstagramStoryWarning.module.scss'
import { DesignChannel } from 'components/NewFileModal/Types'
import { ScheduledPostShow } from 'api/clients/ScheduledPostsClient'
import { Text } from 'blaze-ui/Text/Text'
import { observer } from 'mobx-react-lite'

interface Props {
  scheduledPost: ScheduledPostShow
  channel: DesignChannel
}

export const InstagramStoryWarning = observer(({ scheduledPost, channel }: Props) => {
  if (channel !== DesignChannel.InstagramStory) return null

  return (
    <div className={Styles.validationContainer}>
      <Text variant="secondary" color="var(--yellow-60)">
        Posting to Instagram Stories is only supported for <strong>Instagram Business</strong> accounts.
      </Text>
    </div>
  )
})
